const style = {
    root: {
        display: 'flex',
        flexDirection: 'column' as const,
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        padding: 48,
        textAlign: 'center' as const,
    },
    icon: {
        fontSize: 48,
        opacity: 0.4,
    },
};
export default style;
